"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Calendar = void 0;

var _preact = require("preact");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _CalendarMonth = require("./CalendarMonth");

var _Day = require("./Day");

var _Weekdays = require("./Weekdays");

function areDatesEqual(firstDate, secondDate) {
  if (!firstDate || !secondDate) {
    return false;
  }

  firstDate.setHours(0, 0, 0, 0);
  secondDate.setHours(0, 0, 0, 0);
  return firstDate.getTime() === secondDate.getTime();
}

function isDateInRange(date, rangeStart, rangeEnd) {
  if (!rangeStart || !rangeEnd) {
    return false;
  }

  date.setHours(0, 0, 0, 0);
  rangeStart.setHours(0, 0, 0, 0);
  rangeEnd.setHours(0, 0, 0, 0);
  return date.getTime() >= rangeStart.getTime() && date.getTime() <= rangeEnd.getTime();
}

function isDateOutOfBounds(date, boundaryDate, comparator) {
  var normalizedDate = new Date(date);
  normalizedDate.setHours(0, 0, 0, 0);
  var normalizedBoundary = new Date(boundaryDate);
  normalizedBoundary.setHours(0, 0, 0, 0);
  return comparator === 'before' ? normalizedDate.getTime() < normalizedBoundary.getTime() : normalizedDate.getTime() > normalizedBoundary.getTime();
} // eslint-disable-next-line import/prefer-default-export


var Calendar = function Calendar(_ref) {
  var month = _ref.month,
      year = _ref.year,
      selectedDate = _ref.selectedDate,
      selectedStartDate = _ref.selectedStartDate,
      selectedEndDate = _ref.selectedEndDate,
      today = _ref.today,
      disableOutOfBoundsDates = _ref.disableOutOfBoundsDates,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      onChangeMonth = _ref.onChangeMonth,
      onSelectDate = _ref.onSelectDate;
  var startDay = new Date(year, month).getDay();
  var daysOfPreviousMonth = (0, _toConsumableArray2.default)(Array(startDay)).map(function (empty, idx) {
    return (0, _preact.h)(_Day.Day, {
      key: (idx + 1) * -1,
      disabled: true
    });
  });
  var daysCount = 32 - new Date(year, month, 32).getDate();
  var daysOfCurrentMonth = (0, _toConsumableArray2.default)(Array(daysCount)).map(function (empty, idx) {
    var day = idx + 1;
    var date = new Date(year, month, day);
    var isToday = areDatesEqual(date, today);
    var isRangeStart = areDatesEqual(date, selectedStartDate);
    var isRangeMiddle = isDateInRange(date, selectedStartDate, selectedEndDate);
    var isRangeEnd = areDatesEqual(date, selectedEndDate);
    var isSelected = areDatesEqual(date, selectedDate) || isRangeStart || isRangeEnd;
    var isBeforeMin = minDate ? isDateOutOfBounds(date, minDate, 'before') : false;
    var isAfterMax = maxDate ? isDateOutOfBounds(date, maxDate, 'after') : false;
    var isDisabled = !!disableOutOfBoundsDates && (isBeforeMin || isAfterMax);
    return (0, _preact.h)(_Day.Day, {
      key: day,
      day: day,
      today: isToday,
      onClick: isDisabled ? undefined : onSelectDate,
      selected: isSelected,
      rangeStart: isRangeStart,
      rangeMiddle: isRangeMiddle,
      rangeEnd: isRangeEnd,
      disabled: isDisabled
    });
  });
  return (0, _preact.h)("div", {
    className: "m-calendar"
  }, (0, _preact.h)(_CalendarMonth.CalendarMonth, {
    month: month,
    year: year,
    onChangeMonth: onChangeMonth
  }), (0, _preact.h)(_Weekdays.Weekdays, null), (0, _preact.h)("div", {
    className: "m-month-days"
  }, daysOfPreviousMonth, daysOfCurrentMonth));
};

exports.Calendar = Calendar;